
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/components/ui/form";
import { userSchema } from "./form/userFormSchema";
import UserFormFields from "./form/UserFormFields";
import UserFormActions from "./form/UserFormActions";
import { useCreateUser } from "./form/useCreateUser";
import type { UserFormValues } from "./form/userFormSchema";

interface CreateUserFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

export default function CreateUserForm({ onSuccess, onCancel }: CreateUserFormProps) {
  const { handleSubmit, isSubmitting } = useCreateUser(onSuccess);
  
  const form = useForm<UserFormValues>({
    resolver: zodResolver(userSchema),
    defaultValues: {
      name: "",
      email: "",
      password: "",
      role: "support",
      sendWelcomeEmail: true,
    },
  });

  const onSubmit = async (values: UserFormValues) => {
    await handleSubmit(values);
    if (onSuccess) {
      form.reset();
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <UserFormFields />
        <UserFormActions 
          isSubmitting={isSubmitting} 
          onCancel={onCancel} 
        />
      </form>
    </Form>
  );
}
